import css from 'styled-jsx/css';

const styles = css.global`/* #energia-solar-faq-banner {
    background: #FBFBFB;
  } */
  
  #energia-solar-faq-banner.stacked-banner {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: start;
    position: relative;
  }
  
  #energia-solar-faq-banner .bg-image-wrapper {
    height: calc(100vh - 300px);
    max-height: 454px;
    min-height: 270px;
  }
  
  #energia-solar-faq-banner .bg-image-wrapper picture {
    display: flex;
    width: 100%;
    height: 100%;
  }
  
  #energia-solar-faq-banner .bg-image-wrapper picture img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: top;
  }
  #energia-solar-faq-banner .fade-banner {
    opacity: 0.25;
    background: var(--Red-Red-Boston-01, #C00);
    position: absolute;
    width: 100%;
    height: calc(100vh - 300px);
    max-height: 454px;
    min-height: 270px;
  }
  #energia-solar-faq-banner .fade-banner-gradiente {
    background: linear-gradient(90deg, #900 0%, rgba(153, 0, 0, 0.73) 10.94%, rgba(153, 0, 0, 0.00) 56.77%);
    width: 100%;
    height: calc(100vh - 300px);
    max-height: 454px;
    min-height: 270px;
    position: absolute;
  }
  
  #energia-solar-faq-banner .santander-symbol {
    background-image: url(assets/c2c/banners/santander-symbol.svg);
    width: 100%;
    height: 280px;
    position: absolute;
    left: -90px;
    background-repeat: no-repeat;
    background-size: contain;
  }
  
  #energia-solar-faq-banner .text-box-position {
    margin-top: -200px;
    position: relative;
  }
  
  #energia-solar-faq-banner .text-box {
    background: #990000;
    width: 100%;
    max-width: 849px;
    padding: 24px 16px 40px 16px;
    border-radius: 4px;
    box-sizing: border-box;
    height: 360px;
  }
  
  #energia-solar-faq-banner .text-box .main-text {
    font-family: 'SantanderHeadline';
    font-size: 32px;
    font-weight: 400;
    line-height: 48px;
    text-align: left;
    margin-bottom: 8px;
    color: #fff;
  }
  
  #energia-solar-faq-banner .text-box .alt-text {
    font-family: 'SantanderText';
    font-size: 18px;
    font-weight: 400;
    line-height: 28px;
    text-align: left;
    margin-bottom: 24px;
    color: #fff;
    max-width: 100%;
  }
  
  #energia-solar-faq-banner .text-box .btn-simulate {
    box-sizing: border-box;
    height: 48px;
    width: 200px;
    margin: auto;
  }
  
  
  @media (min-width: 992px) {
    #energia-solar-faq-banner .text-box {
      padding: 24px 25px 24px 47px;
      height: 245px;
    }
  
    #energia-solar-faq-banner .santander-symbol { 
      left: 0;
      width: 537px;
      height: 500px;
    }
  
    #energia-solar-faq-banner .bg-image-wrapper,
    #energia-solar-faq-banner .fade-banner,
    #energia-solar-faq-banner .fade-banner-gradiente {
      height: calc(100vh - 180px);
      max-height: 436px;
      min-height: 300px;
    }

    #energia-solar-faq-banner .text-box .main-text {
      font-size: 40px;
      line-height: 60px;
      margin-bottom: 0;
    }
    
    #energia-solar-faq-banner .text-box .alt-text {
      margin-bottom: 32px;
    }
    
    #energia-solar-faq-banner .text-box .btn-simulate {
      margin: 0;
    }
  }
  /* @media (min-width: 1200px) {
    #energia-solar-faq-banner .bg-image-wrapper picture img {
      object-position: 0 40%;
    } 
  }
  
  @media (min-width: 1600px) {
    #energia-solar-faq-banner .bg-image-wrapper picture img {
      object-position: 0 40%;
    } 
  }
  
  @media (min-width: 1900px) {
    #energia-solar-faq-banner .bg-image-wrapper picture img {
      object-position: 0 39%;
    } 
  } */`;

export default styles;